import axios, { AxiosError } from 'axios';
import AuthResponse from '@/models/AuthResponse';

export default class AxiosHelper {
  public static handleErrorResponse(error: Error | AxiosError) {
    if (axios.isAxiosError(error) && error.response) {
      const data = error.response.data as Record<string, string>;
      return AuthResponse.buildFailedResponse(`${data.code}: ${data.messageEN}`, `${data.code}: ${data.messageNL}`);
    } else {
      return AuthResponse.buildFailedResponse(
        `Er is iets misgegaan: ${error.message}`,
        `Something went wrong: ${error.message}`
      );
    }
  }
}
